var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "content-class": "max-height overflow-hidden", width: "1000" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "d-flex max-height flex-column" },
        [
          _c("DialogHeader", {
            staticStyle: { flex: "0 0!important" },
            attrs: { title: "Import logs" },
            on: {
              close: function ($event) {
                return _vm.close()
              },
            },
          }),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "overflow-auto pb-4", staticStyle: { flex: "1 0" } },
            [
              _vm.loading
                ? _c("PageLoader", {
                    staticClass: "mt-5 pt-5",
                    attrs: { "resource-name": "import logs" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ServiceUserLogs", {
                ref: "serviceUserLogs",
                attrs: {
                  executionId: _vm.executionId,
                  isRollback: _vm.isRollback,
                  loading: _vm.loading,
                },
                on: {
                  "update:loading": function ($event) {
                    _vm.loading = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", { staticStyle: { flex: "0 0" } }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticStyle: { flex: "0 0 !important" } },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }